/* eslint-disable react-hooks/exhaustive-deps */
import { Row, Col, Card, Statistic, Typography, Spin, Divider, Grid } from "antd";

import BlogTreeSelector from "./TreeSelector.jsx";
import AnalyticsGenericBarGraph from "../../common-utils/GenericBarGraph/index.jsx";

const { Title, Text } = Typography;

const TreeNodeAnalytics = ({
  treeData,
  isTreeLoading,
  selectedNodeIdentifier,
  setSelectedNodeIdentifier,
  isLoading,
  treeNodeStatsData
}) => {
  const screens = Grid.useBreakpoint();
  const isDesktopView = screens.lg === true;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "stretch",
        gap: "30px",
        // Keeps the tree panel and its divider running the full height of the viewport
        minHeight: isDesktopView ? "calc(100dvh - 240px)" : undefined
      }}
    >
      <BlogTreeSelector
        selectedNode={selectedNodeIdentifier}
        setSelectedNode={setSelectedNodeIdentifier}
        isLoading={isTreeLoading}
        treeData={treeData}
      />
      <TreeNodeStats
        selectedNodeIdentifier={selectedNodeIdentifier}
        isLoading={isLoading}
        treeNodeStatsData={treeNodeStatsData}
      />
    </div>
  );
};

const TreeNodeStats = ({ selectedNodeIdentifier, isLoading, treeNodeStatsData }) => {
  const {
    summaryStats = {},
    totalVisitsGraphPoints = [],
    totalLikesGraphPoints = [],
    totalDislikesGraphPoints = []
  } = treeNodeStatsData || {};
  return (
    <div style={{ flex: 1, minWidth: "300px", paddingLeft: "20px" }}>
      {isLoading ? (
        <Spin />
      ) : selectedNodeIdentifier ? (
        <>
          <Title level={3} style={{ marginBottom: 20 }}>
            Statistics Overview
          </Title>

          <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
            <Col xs={24} sm={12} md={8}>
              <Card bordered>
                <Statistic title="Visits" value={summaryStats?.totalVisits || 0} />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card bordered>
                <Statistic title="Likes" value={summaryStats?.totalLikes || 0} />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Card bordered>
                <Statistic title="Dislikes" value={summaryStats?.totalDislikes || 0} />
              </Card>
            </Col>
          </Row>

          <Divider />

          <div style={{ marginBottom: 40 }}>
            <Title level={4}>Daily Visit Count</Title>
            <Text type="secondary">
              Shows total visits for all blogs under this tree node, aggregated by day. Repeated
              page refreshes are counted as separate visits.
            </Text>
            {totalVisitsGraphPoints?.length ? (
              <AnalyticsGenericBarGraph dataPoints={totalVisitsGraphPoints} />
            ) : (
              <NoDataAvailable />
            )}
          </div>
          <div style={{ marginBottom: 40 }}>
            <Title level={4}>Daily Likes Count</Title>
            <Text type="secondary">
              Displays total likes recorded per day for blogs under the selected node.
            </Text>
            {totalLikesGraphPoints?.length ? (
              <AnalyticsGenericBarGraph dataPoints={totalLikesGraphPoints} />
            ) : (
              <NoDataAvailable />
            )}
          </div>
          <div style={{ marginBottom: 40 }}>
            <Title level={4}>Daily Dislikes Count</Title>
            <Text type="secondary">
              Displays total dislikes recorded per day for blogs under the selected node.
            </Text>
            {totalDislikesGraphPoints?.length ? (
              <AnalyticsGenericBarGraph dataPoints={totalDislikesGraphPoints} />
            ) : (
              <NoDataAvailable />
            )}
          </div>
        </>
      ) : (
        <p>Select a tree node to view its analytics.</p>
      )}
    </div>
  );
};

const NoDataAvailable = () => (
  <div
    style={{
      textAlign: "center",
      height: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <Text type="secondary">No data available</Text>
  </div>
);

export default TreeNodeAnalytics;
